import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Form from '../../util/Form'
import MlsInput from '../../util/Form/mls'
import { present, email, length, matchesField } from '../../util/Form/validators'

import ResellerTeamsStore from '../../../stores/reseller_teams'
import MlsStore from '../../../stores/mls'
import Provision from '../../../stores/provision'

@inject(['auth'])
@observer
export default class NewCustomer extends Component {
  state = {
    reseller: this.props.auth.user.reseller_team.id,
    mlsCount: 1
  }

  resellerTeams = new ResellerTeamsStore()
  mlsStore = new MlsStore()
  provisionStore = new Provision()

  componentDidMount() {
    if (this.props.auth.user.admin) this.resellerTeams.load()
    this.mlsStore.loadMlsInfo()
  }

  handleData = data => this.provisionStore.create(data)

  handleAddMls = () => this.setState({ mlsCount: this.state.mlsCount + 1 })

  // NOTE: This is called reseller instead of reseller_team_id to match params in the ProvisionController.
  handleReseller = ({ target: { value:reseller } }) => {
    this.setState({ reseller }, () => null)
  }

  renderMlses() {
    const inputs = []

    for (let i = 0; i < this.state.mlsCount; i++) {
      inputs.push(
        <MlsInput validationId={i} key={i} mlsStore={this.mlsStore} />
      )
    }

    return inputs
  }

  renderResellerTeams() {
    const { reseller } = this.state

    if (this.props.auth.user.admin) {
      return (
        <div className="form-section">
          <label htmlFor="reseller">Reseller Team</label>
          <select name="reseller" id="reseller" value={reseller} onChange={this.handleReseller}>
            {this.resellerTeams.map(({ id, name }) => (
              <option key={id} value={id}>{name}</option>
            ))}
          </select>
        </div>
      )
    } else {
      return <input type="hidden" name="reseller" id="reseller" value={reseller} readOnly />
    }
  }

  render() {

    const validations = [
      { field: 'team_name', validate: present, message: 'All customer must have a team name' },
      { field: 'agent_first_name', validate: present, message: 'All agents must have a first name' },
      { field: 'agent_last_name', validate: present, message: 'All agents must have a last name' },
      { field: 'agent_email', validate: [present, email], message: 'All agents must have a valid email' },
      { field: 'agent_url', validate: present, message: 'All agents should have a website URL' },
      { field: 'agent_password', validate: [present, length(8)], message: 'Reseller must have a password of at least 8 characters' },
      { field: 'confirm_password', validate: matchesField('password'), message: 'Confirmation must match password' }
    ]

    for (let i = 0; i < this.state.mlsCount; i++) {
      validations.push({ field: `mls_validation_${i}`, validate: present, message: "Mls cannot be blank" })
    }

    return (
      <div className="container padded teams">
        <Form ref={el => this.form = el && el.form} className="full" validations={validations} onData={this.handleData}>
          <div className="panel full padded">
            <h2 className="title">New Customer</h2>

            {this.renderResellerTeams()}

            <div className="form-section">
              <label htmlFor="plan">Plan</label>
              <select name="plan" id="plan" defaultValue="essentials">
                <option key="essentials" value="essentials">Essentials</option>
                <option key="new_premium" value="new_premium">Premium</option>
              </select>
              <label htmlFor="Rate">Rate</label>
              <select name="rate" id="rate" defaultValue="monthly">
                <option key="monthly" value="monthly">Monthly</option>
                <option key="yearly" value="yearly">Yearly</option>
              </select>
            </div>

            <div className="form-section">
              <label htmlFor="team_name">Team Name</label>
              <input name="team_name" id="team_name" placeholder="Enter a Team Name" />
            </div>

            <div className="form-section">
              <label htmlFor="agent_first_name">Agent First Name</label>
              <input name="agent_first_name" id="agent_first_name" placeholder="Enter a Name" />
              <label htmlFor="agent_last_name">Agent Last Name</label>
              <input name="agent_last_name" id="agent_last_name" placeholder="Enter a Name" />
            </div>

            <div className="form-section">
              <label htmlFor="agent_email">Agent Email</label>
              <input name="agent_email" id="agent_email" placeholder="Enter an Email" />
            </div>

            <div className="form-section">
              <label htmlFor="agent_url">Agent URL</label>
              <input name="agent_url" id="agent_url" placeholder="Enter a URL" />
            </div>

            <div className="form-section">
              <label htmlFor="agent_password">Password</label>
              <input type="password" name="agent_password" id="agent_password" placeholder="Enter a Password" />
              <label htmlFor="confirm_password">Password Confirmation</label>
              <input type="password" name="confirm_password" id="confirm_password" />
            </div>

            {this.renderMlses()}
            <button type="button" onClick={this.handleAddMls}>Add Another MLS</button>

            <button type="submit" className="big shadowed">Add Customer</button>
          </div>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/NewCustomer/index.js